import { PropsWithChildren, ReactNode } from "react";
import { createPortal } from "react-dom";
import { Tooltip as RTooltip } from "react-tooltip";

interface TooltipProps {
  label: ReactNode;
  id: string;
}

const Tooltip = ({ children, id, label }: PropsWithChildren<TooltipProps>) => {
  return (
    <>
      <span data-tooltip-id={id} tabIndex={0} aria-describedby={id}>
        {label}
      </span>
      {createPortal(
        <RTooltip
          id={id}
          positionStrategy="fixed"
          className="Tooltip"
          variant="light"
          arrowSize={15}
        >
          {children}
        </RTooltip>,
        document.body,
      )}
    </>
  );
};

export default Tooltip;
